import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=2f0573e2&scoped=true"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"
import style0 from "./TabView.vue?vue&type=style&index=0&id=2f0573e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0573e2",
  null
  
)

export default component.exports